var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 69.9668L71.0683 36.0235C74.3877 32.7041 79.7696 32.7041 83.0891 36.0236C86.4085 39.343 86.4085 44.7249 83.0891 48.0444L49.1458 81.9876L37.125 69.9668Z",
    fill: "#91CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1328 81.9863L28.9047 61.7013C25.5899 58.3772 25.5975 52.9953 28.9216 49.6805C32.2457 46.3657 37.6276 46.3733 40.9424 49.6974L61.1705 69.9824L49.1328 81.9863Z",
    fill: "#38999F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentComplete);
export default __webpack_public_path__ + "static/media/assessment-complete.2a49a69f90e6a540d5d886319cdc50fe.svg";
export { ForwardRef as ReactComponent };